//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'APRI',
  data() {
    return {
      defaultJson: {
        "Serum AST": "血清 AST",
        "AST Reference value": "AST参考值",
        "Platelet count": "血小板计数",
      },
      form: {
        ast: '',
        reference_value: '',
        plate_count: '',
      },
      hasScore: false,
      disabled: false,
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        let result = 100 * (form.ast / form.reference_value) / form.plate_count
        self.hasScore = true
        return String(result.toFixed(2))
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/GD/APRI.vue